const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export async function GetDashboardStats(requestorId: string | number) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/dashboard/stats?requestorId=${requestorId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        return [];
    }
}
